import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AddEvent, CommonWebService, DEVICE_CREDENTIALS, EventDetail, EventsList, HttpResponse, RevertStatus, UserHttpService } from "../public-api";

@Injectable({
    providedIn: 'root'
})
export class EventsHttpService {

    constructor(
        private http: HttpClient,
        private commonService: CommonWebService,
        private userSessionService: UserHttpService
    ) { }

    public addEvent(body: AddEvent, isEdit: boolean = false): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);

        formData.append('title', body.title ? body.title : "");
        formData.append('eventdate', body.eventdate ? this.commonService.changeDateFormat(body.eventdate as Date) : "");
        formData.append('venue', body.venue ? body.venue : "");
        formData.append('timefrom', body.timefrom ? body.timefrom : "");
        formData.append('timeto', body.timeto ? body.timeto : "");
        formData.append('timezone', body.timezone ? body.timezone : "");
        formData.append('googlemapurl', body.googlemapurl ? body.googlemapurl : "");
        formData.append('description', body.description ? body.description : "");

        if (body.attendees_userid && body.attendees_userid.length > 0) {
            body.attendees_userid.forEach((user, i) => {
                formData.append(`attendees_userid[${i}]`, user ? user : "");
            });
        }


        if (body.group_id && body.group_id.length > 0) {
            body.group_id.forEach((group, i) => {
                formData.append(`group_id[${i}]`, group ? group : "");
            });

        }

        if (body.client_id && body.client_id.length > 0) {
            body.client_id.forEach((client, i) => {
                formData.append(`client_id[${i}]`, client ? client : "");
            });
        }

        if (isEdit) {
            formData.append('event_id', body.event_id ? body.event_id : "");
        }
        return this.http.post<HttpResponse<any>>('events/addEvent', formData);
    }


    public getAllEvents(limit?: number, offset?: number): Observable<HttpResponse<EventsList>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);
        if (limit !== undefined) {
            formData.append('limit', limit.toString());
        }
        if (offset !== undefined) {
            formData.append('offset', offset.toString());
        }
        return this.http.post<HttpResponse<EventsList>>('events/addEvent/getevents', formData);
    }

    public getEventDetail(event_id: string): Observable<HttpResponse<EventDetail[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);

        if (event_id) {
            formData.append("event_id", event_id ? event_id : "");
        };

        return this.http.post<HttpResponse<EventDetail[]>>('events/addEvent/geteventsview', formData);
    }

    public getEventDetailByUser(event_id: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);

        if (event_id) {
            formData.append("event_id", event_id ? event_id : "");
        };

        return this.http.post<HttpResponse<any>>('events/eventDetailSortByUSer', formData);
    }

    public changeEventStatus(body: RevertStatus): Observable<HttpResponse<EventDetail[]>> {
        let formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('event_id', body.event_id ? body.event_id : "");
        formData.append('userFullname', body.userFullname ? body.userFullname : "");
        formData.append('event_status', body.event_status ? body.event_status : "");
        formData.append('deviceToken', DEVICE_CREDENTIALS.DEVICE_TOKEN);
        formData.append('deviceType', DEVICE_CREDENTIALS.DEVICE_TYPE);

        return this.http.post<HttpResponse<EventDetail[]>>('events/eventRevert', formData);
    }
}